export const CarsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.4406 8.99407H2.559C2.34508 8.99407 2.14976 8.90106 2.01954 8.73364C1.88933 8.57553 1.83352 8.3523 1.88003 8.14768L2.93104 3.12513C3.27518 1.49746 3.97275 0 6.73514 0H13.2738C16.0362 0 16.7337 1.50676 17.0779 3.12513L18.1289 8.15698C18.1754 8.3616 18.1196 8.57553 17.9894 8.74294C17.8498 8.90106 17.6545 8.99407 17.4406 8.99407ZM3.41469 7.59892H16.5756L15.7013 3.41346C15.4409 2.19503 15.134 1.39515 13.2645 1.39515H6.73514C4.86564 1.39515 4.55871 2.19503 4.29828 3.41346L3.41469 7.59892Z"
        fill="#292D32"
      />
      <path
        d="M17.4036 19.2251H15.655C14.1482 19.2251 13.8599 18.3601 13.6739 17.7928L13.4879 17.2347C13.246 16.5278 13.2181 16.4348 12.3811 16.4348H7.61895C6.78186 16.4348 6.72605 16.5929 6.51213 17.2347L6.32611 17.7928C6.13079 18.3694 5.85176 19.2251 4.345 19.2251H2.59642C1.86164 19.2251 1.15476 18.9182 0.661812 18.3787C0.178161 17.8486 -0.0543636 17.1417 0.0107432 16.4348L0.531598 10.7705C0.671113 9.23585 1.08036 7.59888 4.06597 7.59888H15.934C18.9196 7.59888 19.3196 9.23585 19.4684 10.7705L19.9893 16.4348C20.0544 17.1417 19.8218 17.8486 19.3382 18.3787C18.8452 18.9182 18.1384 19.2251 17.4036 19.2251ZM7.61895 15.0397H12.3811C14.0738 15.0397 14.4738 15.793 14.8086 16.7789L15.0039 17.3556C15.162 17.83 15.162 17.8393 15.6643 17.8393H17.4129C17.757 17.8393 18.0826 17.6997 18.3151 17.4486C18.5383 17.2068 18.6406 16.8999 18.6127 16.5743L18.0919 10.91C17.9709 9.65439 17.8221 9.00333 15.9526 9.00333H4.06597C2.18717 9.00333 2.03836 9.65439 1.92675 10.91L1.40589 16.5743C1.37799 16.8999 1.4803 17.2068 1.70352 17.4486C1.92675 17.6997 2.26158 17.8393 2.60572 17.8393H4.3543C4.85656 17.8393 4.85656 17.83 5.01467 17.3649L5.20069 16.7975C5.43322 16.0535 5.77735 15.0397 7.61895 15.0397Z"
        fill="#292D32"
      />
      <path
        d="M2.55962 6.20374H1.62952C1.24818 6.20374 0.931946 5.88751 0.931946 5.50617C0.931946 5.12483 1.24818 4.80859 1.62952 4.80859H2.55962C2.94096 4.80859 3.25719 5.12483 3.25719 5.50617C3.25719 5.88751 2.94096 6.20374 2.55962 6.20374Z"
        fill="#292D32"
      />
      <path
        d="M18.3713 6.20374H17.4412C17.0598 6.20374 16.7436 5.88751 16.7436 5.50617C16.7436 5.12483 17.0598 4.80859 17.4412 4.80859H18.3713C18.7526 4.80859 19.0688 5.12483 19.0688 5.50617C19.0688 5.88751 18.7526 6.20374 18.3713 6.20374Z"
        fill="#292D32"
      />
      <path
        d="M10.0004 3.41343C9.61903 3.41343 9.3028 3.09719 9.3028 2.71585V0.855655C9.3028 0.474315 9.61903 0.158081 10.0004 0.158081C10.3817 0.158081 10.6979 0.474315 10.6979 0.855655V2.71585C10.6979 3.09719 10.3817 3.41343 10.0004 3.41343Z"
        fill="#292D32"
      />
      <path
        d="M11.3955 3.41334H8.60523C8.22389 3.41334 7.90765 3.0971 7.90765 2.71576C7.90765 2.33442 8.22389 2.01819 8.60523 2.01819H11.3955C11.7769 2.01819 12.0931 2.33442 12.0931 2.71576C12.0931 3.0971 11.7769 3.41334 11.3955 3.41334Z"
        fill="#292D32"
      />
      <path
        d="M7.2101 12.7144H4.4198C4.03846 12.7144 3.72223 12.3981 3.72223 12.0168C3.72223 11.6354 4.03846 11.3192 4.4198 11.3192H7.2101C7.59144 11.3192 7.90767 11.6354 7.90767 12.0168C7.90767 12.3981 7.59144 12.7144 7.2101 12.7144Z"
        fill="#292D32"
      />
      <path
        d="M15.5809 12.7144H12.7907C12.4093 12.7144 12.0931 12.3981 12.0931 12.0168C12.0931 11.6354 12.4093 11.3192 12.7907 11.3192H15.5809C15.9623 11.3192 16.2785 11.6354 16.2785 12.0168C16.2785 12.3981 15.9623 12.7144 15.5809 12.7144Z"
        fill="#292D32"
      />
    </svg>
  );
};
